angular.module('b2bLoginApp.directives').directive('editPhotoDescription', ["$uibModal", "$http", "TranslationService", function ($uibModal, $http, TranslationService) {
    return {
        restrict: 'A',
        scope: {
            'photo': '='
        },
        template: '<a class="dropdown-item" ng-click="openEditPhotoDialog()">[[ addEditCaptionLabel ]]</a>',
        link: function (scope) {

            var addEditLabel = 'company-profile-public.photos.button.add_caption';
            if (scope.photo.description) {
                addEditLabel = 'company-profile-public.photos.button.edit_caption';
            }
            scope.addEditCaptionLabel = TranslationService.trans(addEditLabel);

            scope.openEditPhotoDialog = function () {
                var modal = $uibModal.open({
                    templateUrl: '/account/company-profile-public/edit-photo-description.html',
                    backdrop: 'static',
                    keyboard: false,
                    scope: scope,
                    size: 'lg',
                    openedClass: 'company-profile-modal company-photos-modal modal-open',
                    controller: ["$scope", function ($scope) {
                        $scope.editPhotoDescription = function () {
                            var storageId = scope.photo.name;
                            $http.put('company-profile-public/photo/' + storageId + '.json', scope.photo).then(function () {
                                modal.close();
                            });
                        };
                    }]
                });
            };
        }
    };
}]);
